import React from 'react'
import Footer from '../footer/footer'
import StudyGer from './StudyGer'

function StudyAtU() {
  return (
    <div>
    <StudyGer
    title="United States"/>
    <Footer/>
    </div>
  )
}

export default StudyAtU